// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tgad","left":"styles_left__3EvIR"};